import React from 'react';
import "./nav.css";
const Nav = () => {
    return (
        <div>
            <nav className="navbar navbar-expand-lg bg-transparent">
                <div className="container mt-5">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter active" aria-current="page" href="#">Home</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter" href="#">Health & Body</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter" href="#">Why Us</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter" href="#">Programs</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter" href="#">Life Club</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link text-white fw-lighter" href="#">Plans</a>
                        </li>
                    </ul>
                    </div>
                </div>
                </nav>
        </div>
    );
}

export default Nav;
